// extracted by mini-css-extract-plugin
export default {"variableAmountInput":"AmountScreen_variableAmountInput__+OAUa"};